var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_639_07893"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_639_07893)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.5,3.75C12.5,3.75,12.5,6.25,12.5,6.25C12.5,6.25,6.25,6.25,6.25,6.25C6.25,6.25,6.25,23.75,6.25,23.75C6.25,23.75,23.75,23.75,23.75,23.75C23.75,23.75,23.75,17.5,23.75,17.5C23.75,17.5,26.25,17.5,26.25,17.5C26.25,17.5,26.25,25,26.25,25C26.25,25.3315,26.1182,25.6495,25.8839,25.8839C25.6495,26.1182,25.3315,26.25,25,26.25C25,26.25,5,26.25,5,26.25C4.66848,26.25,4.350538,26.1182,4.116116,25.8839C3.881696,25.6495,3.7500000000000004,25.3315,3.75,25C3.75,25,3.75,5,3.75,5C3.75,4.66848,3.881696,4.350538,4.116116,4.116116C4.350538,3.881696,4.66848,3.7500000000000004,5,3.75C5,3.75,12.5,3.75,12.5,3.75C12.5,3.75,12.5,3.75,12.5,3.75ZM21.9825,6.25C21.9825,6.25,16.25,6.25,16.25,6.25C16.25,6.25,16.25,3.75,16.25,3.75C16.25,3.75,26.25,3.75,26.25,3.75C26.25,3.75,26.25,13.75,26.25,13.75C26.25,13.75,23.75,13.75,23.75,13.75C23.75,13.75,23.75,8.0175,23.75,8.0175C23.75,8.0175,15,16.7675,15,16.7675C15,16.7675,13.2325,15,13.2325,15C13.2325,15,21.9825,6.25,21.9825,6.25C21.9825,6.25,21.9825,6.25,21.9825,6.25Z",
    fill: "#27314D",
    fillOpacity: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.bf208f033f21227d906f7e35341c2394.svg";
export { ForwardRef as ReactComponent };